import { render, staticRenderFns } from "./MatrixPreviousYearEffects.vue?vue&type=template&id=d4b636f8&"
import script from "./MatrixPreviousYearEffects.vue?vue&type=script&lang=js&"
export * from "./MatrixPreviousYearEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports